import Chip from '@mui/material/Chip';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';
import { getDeadlineInfo } from './deadlineUtils';

/**
 * Chip de fecha límite de una vacante activa:
 * amarillo cuando está cerca (≤ 7 días), rojo cuando cierra hoy o ya venció.
 * No renderiza nada si no corresponde aviso.
 */
const AtsDeadlineChip = ({ position, size = 'small' }) => {
  const { t } = useTranslation();
  const info = getDeadlineInfo(position);
  if (!info) return null;

  let label;
  if (info.daysLeft > 0) {
    label = t('ats.positions.deadline.closesIn', { count: info.daysLeft });
  } else if (info.daysLeft === 0) {
    label = t('ats.positions.deadline.closesToday');
  } else {
    label = t('ats.positions.deadline.overdue', { count: Math.abs(info.daysLeft) });
  }

  return (
    <Chip
      icon={<AccessTimeIcon />}
      label={label}
      color={info.level === 'warning' ? 'warning' : 'error'}
      size={size}
    />
  );
};

export default AtsDeadlineChip;
